import { Parser } from "@siteimprove/alfa-parser";
import { List } from "../collection/index.js";
import { Matrix } from "./matrix.js";
import { Perspective } from "./perspective.js";
import { Rotate } from "./rotate.js";
import { Scale } from "./scale.js";
import { Skew } from "./skew.js";
import { Translate } from "./translate.js";
const { either } = Parser;
/**
 * @public
 */
export var Transform;
(function (Transform) {
    function resolve(resolver) {
        return (value) => value.resolve(resolver);
    }
    Transform.resolve = resolve;
    function partiallyResolve(resolver) {
        return (value) => Translate.isTranslate(value)
            ? value.partiallyResolve(resolver)
            : value.resolve(resolver);
    }
    Transform.partiallyResolve = partiallyResolve;
    function matrix(...values) {
        return Matrix.of(...values);
    }
    Transform.matrix = matrix;
    function perspective(depth) {
        return Perspective.of(depth);
    }
    Transform.perspective = perspective;
    function rotate(x, y, z, angle) {
        return Rotate.of(x, y, z, angle);
    }
    Transform.rotate = rotate;
    function scale(x, y) {
        return Scale.of(x, y);
    }
    Transform.scale = scale;
    function skew(x, y) {
        return Skew.of(x, y);
    }
    Transform.skew = skew;
    function translate(x, y, z) {
        return Translate.of(x, y, z);
    }
    Transform.translate = translate;
    /**
     * {@link https://drafts.csswg.org/css-transforms/#typedef-transform-function}
     *
     * @internal
     */
    Transform.parse = either(Matrix.parse, Perspective.parse, Rotate.parse, Scale.parse, Skew.parse, Translate.parse);
    /**
     * {@link https://drafts.csswg.org/css-transforms/#typedef-transform-list}
     */
    Transform.parseList = List.parseSpaceSeparated(Transform.parse);
})(Transform || (Transform = {}));
//# sourceMappingURL=transform.js.map